export const addhttps = url => {
  if (url.indexOf('://') === -1) {
    return {
      addedHttps: true,
      url: `https://${url}`
    }
  }
  
  return {
    addedHttps: false,
    url
  }
}